import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import FeatureContainer from "../../../Layout/Containers/FeatureContainer";
import { getDateToday } from "../../../Utils/externalFunctions";
import AbsenStafBulananList from "../components/AbsenStafBulananList";
import { Button } from "reactstrap";
import { useAbsensi } from "../../../Context/AbsensiContext";
import { useStaf } from "../../../Context/StafContext";
import { useKalender } from "../../../Context/KalenderContext";

const AbsenStafBulananContain = () => {
  const stafAPI = useStaf();
  const absensiAPI = useAbsensi();
  const kalenderAPI = useKalender();

  // https://stackoverflow.com/questions/45731522/question-mark-inside-react-router-path
  const { search } = useLocation();
  const parameters = new URLSearchParams(search);
  const periode = parameters.get("periode");

  const { stafId } = useParams();

  const [monthFilter, setMonthFilter] = useState(
    periode || getDateToday("original").substring(0, 7)
  );

  const [data, setData] = useState({
    absen: [],
    detailAbsen: [],
    staf: [],
    lokasi: [],
    event: []
  });
  const [pending, setPending] = useState({ absen: false });

  let isMounted = true;
  useEffect(() => {
    const fetchData = async () => {
      refreshAbsen();
      refreshDetailAbsen();
      refreshStaff();
      refreshLokasi();
      refreshGroupStaff();
    };

    if (isMounted) fetchData();
    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    refreshData();
  }, [monthFilter]);

  const refreshData = () => {
    refreshKalender();
    refreshAbsen();
    refreshDetailAbsen();
  };

  const refreshAbsen = () => {
    setPending((prev) => ({ ...prev, absen: true }));
    absensiAPI.getAbsensiByStafAndDate(stafId, monthFilter)
      .then((res) => {
        setData((prev) => ({ ...prev, absen: res.data }));
      })
      .finally(() => {
        setPending((prev) => ({ ...prev, absen: false }));
      });
  };

  const refreshDetailAbsen = () => {
    absensiAPI.getDetailAbsensiByStafAndDate(stafId, monthFilter).then(
      (res) => {
        setData((prev) => ({ ...prev, detailAbsen: res.data }));
      }
    );
  };

  const refreshStaff = async () => {
    stafAPI.getStaf().then((res) => {
      setData((prev) => ({ ...prev, staf: res.data }));
    });
  };

  const refreshLokasi = async () => {
    absensiAPI.getLokasi().then((res) => {
      setData((prev) => ({ ...prev, lokasi: res.data }));
    });
  };

  const refreshGroupStaff = async () => {
    stafAPI.getGroupStaf().then((res) => {
      setData((prev) => ({ ...prev, groupStaff: res.data }));
    });
  };
  
  const refreshKalender = async () => {
    kalenderAPI.getEventByPeriod(monthFilter).then((res) => {
      setData((prev) => ({ ...prev, event: res.data }));
    })
  }

  const updateMonthFilter = (newMonth) => setMonthFilter(newMonth);

  const handleExportAbsenIndividu = () => {
    absensiAPI.getAbsenStafExport(stafId, monthFilter);
  };

  const button = (
    <Button onClick={() => handleExportAbsenIndividu()}>Export PDF</Button>
  );

  return (
    <FeatureContainer title={"Absen"} createButton={button}>
      <AbsenStafBulananList
        data={data}
        resetState={refreshData}
        stafId={stafId}
        updateMonthFilter={updateMonthFilter}
        pending={pending?.absen}
        periode={periode}
        monthFilter={monthFilter}
      />
    </FeatureContainer>
  );
};

export default AbsenStafBulananContain;
